import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography
} from "@mui/material";

type ArchivePropertyDialogProps = {
    isOpen: boolean;
    onClose: () => void;
    onArchive: () => void;
};

const ArchivePropertyDialog = ({ isOpen, onClose, onArchive }: ArchivePropertyDialogProps) => (
    <Dialog open={isOpen} onClose={onClose}>
        <DialogTitle>
            Archive Property
        </DialogTitle>
        <DialogContent>
            <Typography variant="body1" padding={2}>
                Archiving this property will hide it from the property list.
            </Typography>
            <Typography variant="body1" padding={2}>
                You will still be able to search for this property or toggle it's visibility.
            </Typography>
            <Typography variant="body1" padding={2}>
                Do you wish to proceed?
            </Typography>
        </DialogContent>
        <DialogActions>
            <Button variant="contained" color="secondary" onClick={onClose}>
                Cancel
            </Button>
            <Button variant="contained" color="primary" onClick={onArchive}>
                Archive
            </Button>
        </DialogActions>
    </Dialog>
);

export default ArchivePropertyDialog;
